import buildPath from '@/tsClient/utilities/buildPath';
import documentsClient, { ApiDefinition } from '@/tsClient/servers/noodleDocuments';

type THIS_API = ApiDefinition['/internal-data/{internalDataType}']['GET'];
type Input = THIS_API['query'] & THIS_API['params'];
type Output = THIS_API['response'];

const getInternalDataPaginated = async ({ page, perPage, internalDataType, userWorkflowId }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>('/internal-data/{internalDataType}', { internalDataType });
  const response = await documentsClient.get(path, {
    params: { page, perPage, userWorkflowId },
  });
  return response.data;
};

export default getInternalDataPaginated;
